import React from 'react';

interface ChevronIconProps {
    isOpen: boolean;
}

const ChevronIcon: React.FC<ChevronIconProps> = ({ isOpen }) => (
    <svg 
        width="20" 
        height="20" 
        viewBox="0 0 20 20" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        className={isOpen ? 'rotate-90' : ''}
    >
        <mask id="mask0_582_1896" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
            <rect width="20" height="20" fill="white"/>
        </mask>
        <g mask="url(#mask0_582_1896)">
            <path
                d="M12.0622 9.99967L5.93718 3.87467C5.72885 3.66634 5.62816 3.41981 5.6351 3.13509C5.64205 2.85037 5.74968 2.60384 5.95802 2.39551C6.16635 2.18717 6.41288 2.08301 6.6976 2.08301C6.98232 2.08301 7.22885 2.18717 7.43719 2.39551L13.833 8.81217C13.9997 8.97884 14.1247 9.16634 14.208 9.37467C14.2914 9.58301 14.333 9.79134 14.333 9.99967C14.333 10.208 14.2914 10.4163 14.208 10.6247C14.1247 10.833 13.9997 11.0205 13.833 11.1872L7.41635 17.6038C7.20802 17.8122 6.96496 17.9129 6.68718 17.9059C6.40941 17.899 6.16635 17.7913 5.95802 17.583C5.74968 17.3747 5.64552 17.1281 5.64552 16.8434C5.64552 16.5587 5.74968 16.3122 5.95802 16.1038L12.0622 9.99967Z"
                fill="#1C1B1F"
            />
        </g>
    </svg>
);

export default ChevronIcon;
